import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';

import { CloseButton, Dialog, DialogActions, DialogContent, DialogTitle, SubmitButton } from 'components';
import { EmployeeForm } from 'forms';

interface EmployeeCreateDialogProps {
  visible?: boolean;
  setVisible?: (visible: boolean) => void;
  title?: string;
  subtitle?: string;
  submitButtonLabel?: string;
}

export const EmployeeCreateDialog = ({
  visible = false,
  setVisible = () => {},
  title = 'Create a new cleaning professional',
  subtitle = 'Add the information below',
  submitButtonLabel = 'Create',
}: EmployeeCreateDialogProps) => {
  const [loading, setLoading] = useState<boolean>(false);

  const formRef = React.useRef<any>();

  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  const onSubmit = () => {
    formRef.current.onSubmit();
  };

  return (
    <Dialog
      onClose={onClose}
      open={visible}
      PaperProps={{ sx: { marginBottom: 12, overflow: 'unset', position: 'relative' } }}
    >
      <DialogTitle>
        <Box>
          <Typography variant="h5">{title}</Typography>

          <Typography
            variant="body2"
            color="textSecondary"
            sx={{
              marginTop: 1,
            }}
          >
            {subtitle}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box paddingTop={2}>
          <EmployeeForm
            ref={formRef}
            onSubmitting={(loading) => setLoading(loading)}
            next={() => {
              setVisible(false);
            }}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <SubmitButton loading={loading} label={submitButtonLabel} onClick={onSubmit} />
      </DialogActions>

      <CloseButton onClick={() => onClose(null, 'anyway')} />
    </Dialog>
  );
};
